import React from 'react';

const AlertDiv = ({error, success, title, message }) => {

    //const {error, success, title, message } = props;

    const color = error ? '#cc3737' : (success ? '#63C730' : 'yellow')

    return(
        <div className="form-group" style={{border: `1px solid ${color}`, padding: 10, lineHeight: 1.2}}>
            <div style={{color: color, fontWeight: 'bold'}}>{title}</div>
            <div style={{color: color}}>{message}</div>
        </div>
    )
}

export default AlertDiv